// Tema davranışları: yaş kapısı, animasyonlar, sepet çekmecesi (Ajax Cart API), ürün seçenekleri.
(() => {
  const azHareket = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const tasarimModu = !!(window.Shopify && window.Shopify.designMode);
  const T = window.tema || {};
  const $ = (s, k = document) => k.querySelector(s);
  const $$ = (s, k = document) => [...k.querySelectorAll(s)];
  const kacis = (m) => String(m ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // Para biçimi (mağazanın money_format ayarına göre)
  const para = (kurus) => {
    const n = (kurus || 0) / 100;
    const bicim = T.para || '${{amount}}';
    return bicim.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toLocaleString('de-DE');
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  };

  // 18+ girişi; onaydan sonra açılış animasyonu başlar
  const basla = () => requestAnimationFrame(() => document.body.classList.add('basla'));
  const kapi = $('#yasKapisi');
  if (!kapi || tasarimModu) { if (kapi) kapi.hidden = true; basla(); }
  else {
    let onayli = false;
    try { onayli = localStorage.getItem('yas_onay') === '1'; } catch (e) {}
    if (onayli) { kapi.hidden = true; basla(); }
    else { kapi.hidden = false; document.documentElement.style.overflow = 'hidden'; $('#yasEvet')?.focus(); }
    $('#yasEvet')?.addEventListener('click', () => {
      try { localStorage.setItem('yas_onay', '1'); } catch (e) {}
      kapi.classList.add('kapaniyor');
      document.documentElement.style.overflow = '';
      setTimeout(() => { kapi.hidden = true; basla(); }, azHareket ? 0 : 450);
    });
  }

  // Kaydırınca belirme (başlıklar maskenin altından yükselir)
  const belirt = (kok = document) => {
    $$('.b2[data-goster], .b4[data-goster]', kok).forEach(h => { if (!h.querySelector(':scope > .ic')) h.innerHTML = `<span class="ic">${h.innerHTML}</span>`; });
    const hedefler = $$('[data-goster]:not(.gorundu)', kok);
    if (azHareket || tasarimModu || !('IntersectionObserver' in window)) return hedefler.forEach(e => e.classList.add('gorundu'));
    const io = new IntersectionObserver((kayitlar) => kayitlar.forEach(k => { if (k.isIntersecting) { k.target.classList.add('gorundu'); io.unobserve(k.target); } }), { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    hedefler.forEach(e => io.observe(e));
  };
  belirt();

  // Başlık gölgesi
  const ust = $('.ust');
  if (ust) addEventListener('scroll', () => ust.classList.toggle('kaydi', scrollY > 40), { passive: true });

  // Mobil menü
  const mobilMenu = $('#mobilMenu');
  const menuDugme = $('[data-menu-ac]');
  const menuKapat = () => { mobilMenu?.classList.remove('acik'); menuDugme?.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; };
  menuDugme?.addEventListener('click', () => { mobilMenu.classList.add('acik'); menuDugme.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; $('[data-menu-kapat]', mobilMenu)?.focus(); });
  $('[data-menu-kapat]')?.addEventListener('click', () => { menuKapat(); menuDugme?.focus(); });

  // Shop açılır kategori paneli: dokunmatikte tıklayınca açılır, dışarı tıklayınca / Esc ile kapanır
  $$('[data-acilir]').forEach(li => {
    const d = $('.menu-dugme', li);
    const kapat = () => { li.classList.remove('acik'); d.setAttribute('aria-expanded', 'false'); };
    d.addEventListener('click', (e) => { e.stopPropagation(); const acik = li.classList.toggle('acik'); d.setAttribute('aria-expanded', acik); });
    document.addEventListener('click', (e) => { if (!li.contains(e.target)) kapat(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') kapat(); });
  });

  // Kahraman: imlece göre hafif derinlik
  const vitrin = $('.vitrin');
  if (vitrin && !azHareket && matchMedia('(hover: hover)').matches) {
    vitrin.closest('.kahraman').addEventListener('mousemove', (e) => {
      vitrin.style.setProperty('--mx', (e.clientX / innerWidth - 0.5).toFixed(3));
      vitrin.style.setProperty('--my', (e.clientY / innerHeight - 0.5).toFixed(3));
    });
  }

  // İhtiyaç listesi: imleci yumuşakça izleyen obje
  $$('[data-ihtiyac]').forEach(liste => {
    const takip = $('.takip', liste.closest('section'));
    if (!takip || azHareket) return;
    const cakil = $('.cakil', takip);
    let tx = 0, ty = 0, hx = 0, hy = 0, acik = false, kare = null;
    const izle = () => {
      tx += (hx - tx) * 0.14; ty += (hy - ty) * 0.14;
      takip.style.left = tx + 'px'; takip.style.top = ty + 'px';
      kare = (acik || Math.abs(hx - tx) > 0.5) ? requestAnimationFrame(izle) : null;
    };
    liste.addEventListener('mousemove', (e) => { hx = e.clientX + 110; hy = e.clientY; if (!acik) { tx = hx; ty = hy; } if (!kare) kare = requestAnimationFrame(izle); });
    liste.addEventListener('mouseover', (e) => { const a = e.target.closest('a'); if (a) { cakil.style.setProperty('--renk', a.dataset.renk); takip.classList.add('acik'); acik = true; } });
    liste.addEventListener('mouseleave', () => { takip.classList.remove('acik'); acik = false; });
  });

  // Gizli teslimat kutusu: kayar seçici, görünce bir kez kendiliğinden açılır
  $$('[data-kutu]').forEach(bolum => {
    const koli = $('.koli', bolum), kayar = $('.kayar', bolum);
    const [disB, icB] = $$('.gecis button', bolum);
    if (!koli || !disB || !icB) return;
    let secildi = false;
    const yerlestir = () => { const a = koli.classList.contains('acik') ? icB : disB; kayar.style.width = a.offsetWidth + 'px'; kayar.style.transform = `translate(${a.offsetLeft - 5}px, ${a.offsetTop - 5}px)`; };
    const goster = (ic) => { koli.classList.toggle('acik', ic); icB.setAttribute('aria-pressed', ic); disB.setAttribute('aria-pressed', !ic); yerlestir(); };
    disB.addEventListener('click', () => { secildi = true; goster(false); });
    icB.addEventListener('click', () => { secildi = true; goster(true); });
    addEventListener('resize', yerlestir);
    document.fonts?.ready.then(yerlestir);
    yerlestir();
    if (!azHareket && !tasarimModu && 'IntersectionObserver' in window) {
      const kio = new IntersectionObserver(([k]) => { if (k.isIntersecting) { kio.disconnect(); setTimeout(() => { if (!secildi) goster(true); }, 1600); } }, { threshold: 0.6 });
      kio.observe(koli);
    }
  });

  /* ---------- Sepet ---------- */
  const cekmece = $('#cekmece');
  const sayilar = () => $$('[data-sepet-sayi]');
  const sepetAc = () => { if (!cekmece) return; document.body.classList.add('sepet-acik'); cekmece.setAttribute('aria-hidden', 'false'); setTimeout(() => $('[data-sepet-kapat]', cekmece)?.focus(), 50); };
  const sepetKapat = () => { document.body.classList.remove('sepet-acik'); cekmece?.setAttribute('aria-hidden', 'true'); };
  $$('[data-sepet-ac]').forEach(b => b.addEventListener('click', (e) => { if (!cekmece || document.body.classList.contains('sablon-cart')) return; e.preventDefault(); sepetGetir().then(sepetAc); }));
  $$('[data-sepet-kapat]').forEach(b => b.addEventListener('click', sepetKapat));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { sepetKapat(); menuKapat(); } });

  const istek = async (url, govde) => {
    const c = await fetch(url, govde ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(govde) } : { headers: { Accept: 'application/json' } });
    const veri = await c.json();
    if (!c.ok) throw new Error(veri.description || veri.message || 'Something went wrong. Please try again.');
    return veri;
  };

  const sayiGuncelle = (n, zipla) => sayilar().forEach(s => {
    s.textContent = n;
    if (zipla) { s.classList.remove('zipla'); void s.offsetWidth; s.classList.add('zipla'); }
  });

  const pastel = ['var(--pembe)', 'var(--buz)', 'var(--adacayi)', 'var(--sis-koyu)'];
  const sepetCiz = (sepet) => {
    if (!cekmece) return;
    const govde = $('[data-sepet-govde]', cekmece);
    const alt = $('[data-sepet-alt]', cekmece);
    sayiGuncelle(sepet.item_count);
    if (!sepet.item_count) {
      govde.innerHTML = `<div class="bos"><p>${kacis(T.metin?.sepetBos || 'Your bag is empty.')}</p><a class="dugme dugme-cizgi" href="${T.rotalar?.tumUrunler || '/collections/all'}">${kacis(T.metin?.alisverise || 'Start shopping')}</a></div>`;
      alt.hidden = true;
      return;
    }
    alt.hidden = false;
    govde.innerHTML = sepet.items.map((u, i) => `
      <div class="satir" style="--i:${i}" data-anahtar="${kacis(u.key)}">
        <a class="mini" href="${kacis(u.url)}" style="background:${pastel[i % 4]}" tabindex="-1" aria-hidden="true">${u.image ? `<img src="${kacis(u.image + (u.image.includes('?') ? '&' : '?') + 'width=200')}" alt="" loading="lazy">` : '<div class="cakil"></div>'}</a>
        <div>
          <a class="satir-ad" href="${kacis(u.url)}">${kacis(u.product_title)}</a>
          ${u.variant_title && !u.product_has_only_default_variant ? `<div class="satir-alt">${kacis(u.variant_title)}</div>` : ''}
          <div class="adet" role="group" aria-label="Quantity for ${kacis(u.product_title)}">
            <button type="button" data-adet="${u.quantity - 1}" aria-label="Decrease quantity">&minus;</button>
            <span aria-live="polite">${u.quantity}</span>
            <button type="button" data-adet="${u.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div class="fiyat" style="justify-content:flex-end">${u.original_line_price > u.final_line_price ? `<s>${para(u.original_line_price)}</s>` : ''}${para(u.final_line_price)}</div>
          <button type="button" class="kapat" data-adet="0" style="font-size:14px;margin-top:8px">Remove</button>
        </div>
      </div>`).join('');
    $('[data-sepet-toplam]', cekmece).textContent = para(sepet.total_price);
  };

  const sepetGetir = () => istek(`${T.rotalar?.sepet || '/cart'}.js`).then(s => { sepetCiz(s); return s; }).catch(() => {});

  cekmece?.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-adet]');
    if (!b) return;
    const satir = b.closest('[data-anahtar]');
    satir.classList.add('yukleniyor');
    try { sepetCiz(await istek(`${T.rotalar?.degistir || '/cart/change'}.js`, { id: satir.dataset.anahtar, quantity: parseInt(b.dataset.adet, 10) })); }
    catch (err) { satir.classList.remove('yukleniyor'); alert(err.message); }
  });

  // Ürün, kavis çizerek sepete uçar
  const sepeteUcur = (kaynak, renk) => new Promise(coz => {
    let bitti = () => { bitti = () => {}; coz(); };
    const hedef = sayilar().find(s => s.offsetParent);
    if (azHareket || document.hidden || !kaynak || !hedef) return bitti();
    // Sekme arka plandaysa animasyon durabilir; en geç 1 sn sonra devam et
    setTimeout(() => { document.querySelectorAll('.ucan').forEach(x => x.remove()); bitti(); }, 1000);
    const a = kaynak.getBoundingClientRect(), b = hedef.getBoundingClientRect();
    const el = document.createElement('div');
    el.className = 'ucan';
    el.innerHTML = `<div class="cakil" style="--renk:${renk || '#C98BB3'}"></div>`;
    const x0 = a.left + a.width / 2 - 18, y0 = a.top + a.height / 2 - 26;
    el.style.left = x0 + 'px'; el.style.top = y0 + 'px';
    document.body.appendChild(el);
    const dx = b.left + b.width / 2 - 18 - x0, dy = b.top + b.height / 2 - 26 - y0;
    el.animate([
      { transform: 'translate(0,0) scale(1) rotate(-14deg)' },
      { transform: `translate(${dx * 0.45}px, ${Math.min(dy, 0) - 120}px) scale(.9) rotate(120deg)`, offset: 0.5 },
      { transform: `translate(${dx}px, ${dy}px) scale(.3) rotate(260deg)`, opacity: 0.6 },
    ], { duration: 750, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = () => { el.remove(); bitti(); };
  });

  const sepeteEkle = async (veri, kaynak, dugme, mesajAlani) => {
    const eski = dugme?.innerHTML;
    if (dugme) { dugme.disabled = true; dugme.textContent = T.metin?.ekleniyor || 'Adding…'; }
    if (mesajAlani) mesajAlani.textContent = '';
    try {
      await istek(`${T.rotalar?.sepetEkle || '/cart/add'}.js`, veri);
      await sepeteUcur(kaynak, kaynak?.dataset.renk);
      const s = await sepetGetir();
      sayiGuncelle(s?.item_count ?? '', true);
      if (T.sepetDavranisi === 'sayfa') location.href = T.rotalar?.sepet || '/cart';
      else setTimeout(sepetAc, 250);
    } catch (err) {
      if (mesajAlani) mesajAlani.textContent = err.message; else alert(err.message);
    } finally {
      if (dugme) { dugme.disabled = false; dugme.innerHTML = eski; }
    }
  };

  // Ürün kartındaki hızlı ekleme
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-hizli-ekle]');
    if (!b) return;
    e.preventDefault();
    sepeteEkle({ items: [{ id: parseInt(b.dataset.hizliEkle, 10), quantity: 1 }] }, b.closest('.urun-kart')?.querySelector('.kaide'), b);
  });

  /* ---------- Ürün sayfası ---------- */
  $$('[data-urun]').forEach(kok => {
    const varyantlar = JSON.parse($('[data-varyantlar]', kok)?.textContent || '[]');
    const form = $('form[data-urun-formu]', kok);
    const idGirdi = form && $('input[name="id"]', form);
    const ekleDugme = form && $('[data-ekle-dugme]', form);
    const fiyatAlan = $('[data-fiyat]', kok);
    const mesaj = $('[data-durum-mesaj]', kok);
    const anaGorsel = $('[data-ana-gorsel]', kok) || $('.galeri-ana img', kok);

    // Galeri
    const gorselGoster = (src, srcset, alt, dugme) => {
      if (!anaGorsel || !src) return;
      anaGorsel.classList.add('degisiyor');
      setTimeout(() => {
        anaGorsel.src = src; if (srcset) anaGorsel.srcset = srcset; anaGorsel.alt = alt || '';
        anaGorsel.onload = () => anaGorsel.classList.remove('degisiyor');
        if (anaGorsel.complete) anaGorsel.classList.remove('degisiyor');
      }, azHareket ? 0 : 180);
      $$('[data-kucuk]', kok).forEach(k => k.setAttribute('aria-current', k === dugme ? 'true' : 'false'));
    };
    $$('[data-kucuk]', kok).forEach(k => k.addEventListener('click', () => gorselGoster(k.dataset.src, k.dataset.srcset, k.dataset.alt, k)));

    // Seçenekler
    const secimler = () => $$('[data-secenek]', kok).map(fs => $('input:checked', fs)?.value ?? $('select', fs)?.value);
    const varyantBul = () => { const s = secimler(); return varyantlar.find(v => v.options.every((o, i) => o === s[i])); };
    const guncelle = () => {
      const v = varyantBul();
      // Mevcut seçimlerle olmayan kombinasyonları işaretle
      const s = secimler();
      $$('[data-secenek]', kok).forEach((fs, i) => $$('input', fs).forEach(inp => {
        const deneme = [...s]; deneme[i] = inp.value;
        inp.classList.toggle('yok', !varyantlar.some(x => x.available && x.options.every((o, j) => o === deneme[j])));
      }));
      if (!v) { ekleDugme.disabled = true; ekleDugme.textContent = T.metin?.yok || 'Unavailable'; return; }
      idGirdi.value = v.id;
      ekleDugme.disabled = !v.available;
      ekleDugme.textContent = v.available ? (T.metin?.ekle || 'Add to bag') : (T.metin?.tukendi || 'Sold out');
      if (fiyatAlan) fiyatAlan.innerHTML = `${v.compare_at_price > v.price ? `<s>${para(v.compare_at_price)}</s>` : ''}<span>${para(v.price)}</span>`;
      if (v.featured_media) {
        const k = $(`[data-kucuk][data-medya="${v.featured_media.id}"]`, kok);
        if (k) gorselGoster(k.dataset.src, k.dataset.srcset, k.dataset.alt, k);
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('[data-secenek]', kok).forEach(fs => fs.addEventListener('change', guncelle));
    if ($$('[data-secenek]', kok).length) guncelle();

    // Adet
    const adetGirdi = form && $('input[name="quantity"]', form);
    $$('[data-adet-degistir]', kok).forEach(b => b.addEventListener('click', () => {
      adetGirdi.value = Math.max(1, (parseInt(adetGirdi.value, 10) || 1) + parseInt(b.dataset.adetDegistir, 10));
    }));

    form?.addEventListener('submit', (e) => {
      if (!cekmece && T.sepetDavranisi === 'sayfa') return; // normal form gönderimi
      e.preventDefault();
      sepeteEkle({ items: [{ id: parseInt(idGirdi.value, 10), quantity: parseInt(adetGirdi?.value, 10) || 1 }] }, $('.galeri-ana', kok), ekleDugme, mesaj);
    });
  });

  // Ürün önerileri (Section Rendering API)
  $$('[data-oneriler]').forEach(async (kap) => {
    try {
      const c = await fetch(kap.dataset.url);
      const html = await c.text();
      const gecici = document.createElement('div');
      gecici.innerHTML = html;
      const yeni = gecici.querySelector('[data-oneriler]');
      if (yeni && yeni.innerHTML.trim()) { kap.innerHTML = yeni.innerHTML; belirt(kap); }
    } catch (e) {}
  });

  // Koleksiyon: sıralama ve filtreler değişince formu gönder
  $$('[data-oto-gonder]').forEach(f => f.addEventListener('change', (e) => {
    if (e.target.matches('input[type="number"]')) return;
    f.requestSubmit ? f.requestSubmit() : f.submit();
  }));

  // Tema düzenleyicide bölüm yeniden yüklenince animasyonları yeniden bağla
  document.addEventListener('shopify:section:load', (e) => belirt(e.target));
})();
